import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {

  constructor(private titleService: Title) {
    titleService.setTitle("Terms and Conditions | OneStop Logistics");
  }

  ngOnInit() {
  }

}
